import { storeToRefs } from 'pinia';
import { paginationStore } from '~/stores/pagination';

export default function () {

  const store = paginationStore();
  const { currentPage } = storeToRefs(store);

  return {
    ...store,
    currentPage,
  };

}